/* AutoCave garage + YMM console engine (retail port).
   Depends on window.AC_FITMENTS (ac-fitments.js). No jQuery, no apps. */
(function () {
  'use strict';

  var PACK = window.AC_FITMENTS || {};
  var DB = PACK.db || {};
  var HANDLES = PACK.h || [];
  var LS_KEY = 'ac_garage_vehicle';
  var FINDER_URL = '/pages/parts-finder';

  function onFinderPage() {
    return !!document.querySelector('[data-ac-finder-page]');
  }

  function finderUrl(v) {
    if (!v) return FINDER_URL;
    return FINDER_URL + '?make=' + encodeURIComponent(v.make) +
      '&model=' + encodeURIComponent(v.model) +
      '&year=' + encodeURIComponent(v.year);
  }

  /* ---------- garage state ---------- */

  function getVehicle() {
    try { return JSON.parse(localStorage.getItem(LS_KEY)); } catch (e) { return null; }
  }

  function setVehicle(v) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(v)); } catch (e) { /* private mode */ }
    syncCartAttribute(v);
    renderChip();
  }

  function clearVehicle() {
    try { localStorage.removeItem(LS_KEY); } catch (e) {}
    syncCartAttribute(null);
    renderChip();
    renderProductBadge();
  }

  function vehicleLabel(v) {
    return v ? (v.make + ' ' + v.model + ' ' + v.year) : '';
  }

  function vehicleProducts(v) {
    // DB format: make -> model -> yearLabel -> [handle indexes into HANDLES]
    var idxs;
    try { idxs = DB[v.make][v.model][v.year] || []; } catch (e) { return []; }
    return idxs.map(function (i) { return HANDLES[i]; });
  }

  function syncCartAttribute(v) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Vehicle': v ? vehicleLabel(v) : '' } })
    }).catch(function () {});
  }

  /* ---------- header chip ---------- */

  function renderChip() {
    var slot = document.getElementById('ac-garage-chip');
    if (!slot) return;
    var v = getVehicle();

    if (!v) {
      slot.innerHTML = '';
      slot.classList.remove('is-set');
      return;
    }

    slot.classList.add('is-set');
    slot.innerHTML =
      '<a class="ac-chip" href="' + finderUrl(v) + '" title="Your vehicle — view all parts">' +
        '<svg class="ac-chip__car" viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path fill="currentColor" d="M18.9 6.5c-.2-.6-.8-1-1.4-1H6.5c-.6 0-1.2.4-1.4 1L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.1-5.5zM6.85 7h10.29l1.08 3H5.77l1.08-3zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>' +
        '<span class="ac-chip__label">' + escapeHtml(v.model) + '</span>' +
      '</a>' +
      '<button type="button" class="ac-chip__clear" aria-label="Clear vehicle">&times;</button>';

    slot.querySelector('.ac-chip__clear').addEventListener('click', clearVehicle);
  }

  /* ---------- YMM console ---------- */

  function makes() {
    return Object.keys(DB).sort();
  }

  function modelsFor(make) {
    return Object.keys(DB[make] || {}).sort();
  }

  function yearsFor(make, model) {
    var labels;
    try { labels = Object.keys(DB[make][model]); } catch (err) { return []; }
    // sort newest first by the first 4-digit year found in the label, then alphabetically
    function firstYear(s) { var m = String(s).match(/(19|20)\d{2}/); return m ? parseInt(m[0], 10) : 0; }
    return labels.sort(function (a, b) {
      return (firstYear(b) - firstYear(a)) || a.localeCompare(b);
    });
  }

  function fill(select, options, placeholder) {
    select.innerHTML = '';
    var o = document.createElement('option');
    o.value = '';
    o.textContent = placeholder;
    select.appendChild(o);
    options.forEach(function (val) {
      var opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;
      select.appendChild(opt);
    });
  }

  function initConsole() {
    var root = document.getElementById('ac-console');
    if (!root) return;

    var yearSel = root.querySelector('[data-ac-year]');
    var makeSel = root.querySelector('[data-ac-make]');
    var modelSel = root.querySelector('[data-ac-model]');
    var btn = root.querySelector('[data-ac-find]');
    var status = root.querySelector('[data-ac-status]');

    fill(makeSel, makes(), 'Select make');
    fill(modelSel, [], 'Select model');
    fill(yearSel, [], 'Select year');
    modelSel.disabled = true;
    yearSel.disabled = true;
    btn.disabled = true;

    makeSel.addEventListener('change', function () {
      fill(yearSel, [], 'Select year');
      yearSel.disabled = true;
      btn.disabled = true;
      if (!makeSel.value) { fill(modelSel, [], 'Select model'); modelSel.disabled = true; return; }
      fill(modelSel, modelsFor(makeSel.value), 'Select model');
      modelSel.disabled = false;
    });

    modelSel.addEventListener('change', function () {
      btn.disabled = true;
      if (!modelSel.value) { fill(yearSel, [], 'Select year'); yearSel.disabled = true; return; }
      fill(yearSel, yearsFor(makeSel.value, modelSel.value), 'Select year');
      yearSel.disabled = false;
    });

    yearSel.addEventListener('change', function () {
      btn.disabled = !yearSel.value;
    });

    btn.addEventListener('click', function () {
      if (!yearSel.value) return;
      var v = { year: yearSel.value, make: makeSel.value, model: modelSel.value };
      setVehicle(v);
      if (onFinderPage()) {
        renderResults(v);
        try { history.replaceState(null, '', finderUrl(v)); } catch (e) {}
      } else {
        window.location.href = finderUrl(v);
      }
    });

    function applySelection(v) {
      makeSel.value = v.make;
      makeSel.dispatchEvent(new Event('change'));
      modelSel.value = v.model;
      modelSel.dispatchEvent(new Event('change'));
      if (DB[v.make] && DB[v.make][v.model] && DB[v.make][v.model][v.year]) {
        yearSel.value = String(v.year);
        yearSel.dispatchEvent(new Event('change'));
      }
    }

    // finder page with ?make=&model=&year= — render straight away
    var params = new URLSearchParams(window.location.search);
    var pv = { make: params.get('make'), model: params.get('model'), year: params.get('year') };
    if (onFinderPage() && pv.make && pv.model && pv.year && DB[pv.make] && DB[pv.make][pv.model] && DB[pv.make][pv.model][pv.year]) {
      applySelection(pv);
      setVehicle(pv);
      renderResults(pv, true);
    } else {
      // restore selection for a returning driver — no auto-render, no auto-scroll
      var v = getVehicle();
      if (v && DB[v.make] && DB[v.make][v.model]) {
        applySelection(v);
        if (onFinderPage() && DB[v.make][v.model][v.year]) renderResults(v, true);
      }
    }

    if (status) status.textContent = makes().length + ' makes on file • fitment checked before dispatch';
  }

  /* ---------- results filter bar ---------- */

  var resultItems = [];
  var filtersWired = false;

  function filterEls() {
    return {
      bar: document.querySelector('[data-ac-filterbar]'),
      type: document.querySelector('[data-ac-filter-type]'),
      brand: document.querySelector('[data-ac-filter-brand]'),
      sort: document.querySelector('[data-ac-sort]'),
      count: document.querySelector('[data-ac-filter-count]')
    };
  }

  function fillFilter(select, values, allLabel) {
    var current = select.value;
    select.innerHTML = '';
    var all = document.createElement('option');
    all.value = '';
    all.textContent = allLabel;
    select.appendChild(all);
    values.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v;
      o.textContent = v;
      select.appendChild(o);
    });
    if (values.indexOf(current) !== -1) select.value = current;
  }

  function refreshFilterOptions() {
    var f = filterEls();
    if (!f.bar) return;
    var types = {}, brands = {};
    resultItems.forEach(function (it) {
      if (it.type) types[it.type] = true;
      if (it.vendor) brands[it.vendor] = true;
    });
    fillFilter(f.type, Object.keys(types).sort(), 'All product types');
    fillFilter(f.brand, Object.keys(brands).sort(), 'All brands');
    f.bar.hidden = resultItems.length === 0;
  }

  function applyFilters() {
    var f = filterEls();
    if (!f.bar) return;
    var tv = f.type.value, bv = f.brand.value;
    var shown = 0;
    var visibleItems = [];
    resultItems.forEach(function (it) {
      var show = (!tv || it.type === tv) && (!bv || it.vendor === bv);
      it.card.style.display = show ? '' : 'none';
      if (show) { shown++; visibleItems.push(it); }
    });
    if (f.sort.value) {
      var dir = f.sort.value === 'price-asc' ? 1 : -1;
      visibleItems.sort(function (a, b) { return (a.price - b.price) * dir; });
      var grid = document.querySelector('[data-ac-grid]');
      if (grid) visibleItems.forEach(function (it) { grid.appendChild(it.card); });
    }
    if (f.count) {
      f.count.textContent = (tv || bv)
        ? 'Showing ' + shown + ' of ' + resultItems.length + ' parts'
        : resultItems.length + ' parts';
    }
  }

  function wireFilters() {
    if (filtersWired) return;
    var f = filterEls();
    if (!f.bar) return;
    filtersWired = true;
    [f.type, f.brand, f.sort].forEach(function (sel) {
      sel.addEventListener('change', applyFilters);
    });
  }

  /* ---------- results panel ---------- */

  function money(cents) {
    var d = (cents / 100);
    return '$' + d.toLocaleString('en-AU', { minimumFractionDigits: d % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
  }

  function renderResults(v, noScroll) {
    var panel = document.getElementById('ac-results');
    if (!panel) return;

    var handles = vehicleProducts(v);
    var countLine = handles.length + ' parts on file for <span>' + escapeHtml(vehicleLabel(v)) + '</span>';

    // reset filter state for the new vehicle
    resultItems = [];
    var fEls = filterEls();
    if (fEls.bar) { fEls.bar.hidden = true; if (fEls.count) fEls.count.textContent = ''; }

    if (!handles.length) {
      panel.innerHTML =
        '<div class="ac-results__head">' +
          '<p class="ac-results__count">No parts on file for <span>' + escapeHtml(vehicleLabel(v)) + '</span> yet — call 02 9188 8055 and we’ll source it</p>' +
        '</div>';
      panel.hidden = false;
      return;
    }

    panel.innerHTML =
      '<div class="ac-results__head">' +
        '<p class="ac-results__count">' + countLine + '</p>' +
      '</div>' +
      '<div class="ac-results__grid" data-ac-grid></div>';
    panel.hidden = false;

    var grid = panel.querySelector('[data-ac-grid]');

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) {
          var img = (p.featured_image || (p.images && p.images[0]) || '');
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          if (img) img = img.replace(/(\.[a-z]{3,4})(\?|$)/, '_400x$1$2');

          var compare = p.compare_at_price && p.compare_at_price > p.price
            ? '<s class="ac-card__compare">' + money(p.compare_at_price) + '</s>'
            : '';

          var card = document.createElement('a');
          card.className = 'ac-card';
          card.href = p.url;
          card.innerHTML =
            '<span class="ac-card__fit">Fits your ' + escapeHtml(v.model) + ' &#10003;</span>' +
            (img ? '<span class="ac-card__media"><img loading="lazy" src="' + img + '" alt=""></span>' : '') +
            '<span class="ac-card__vendor">' + escapeHtml(p.vendor || '') + '</span>' +
            '<span class="ac-card__title">' + escapeHtml(p.title) + '</span>' +
            '<span class="ac-card__price">' + money(p.price) + ' ' + compare + '</span>';
          grid.appendChild(card);
          resultItems.push({ card: card, type: p.type || '', vendor: p.vendor || '', price: p.price || 0 });
          refreshFilterOptions();
          applyFilters();
        })
        .catch(function () { /* product hidden/unavailable — skip silently */ });
    });

    wireFilters();

    if (!noScroll) {
      var y = panel.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  /* ---------- product page fitment badge ---------- */

  var handleSet = null;
  function productInDb(handle) {
    if (!handleSet) {
      handleSet = {};
      HANDLES.forEach(function (h) { handleSet[h] = true; });
    }
    return !!handleSet[handle];
  }

  function currentProductHandle() {
    var m = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
    return m ? m[1] : null;
  }

  function renderProductBadge() {
    var slot = document.getElementById('ac-fitment-slot');
    var handle = currentProductHandle();
    if (!slot || !handle) return;

    // universal products (no fitment data) get no badge at all
    if (!productInDb(handle)) { slot.innerHTML = ''; return; }

    var v = getVehicle();
    if (!v) {
      slot.innerHTML =
        '<a class="ac-fit ac-fit--none" href="' + FINDER_URL + '">' +
          '<span class="ac-fit__dot"></span>Select your vehicle to confirm fitment &rarr;' +
        '</a>';
      return;
    }

    var fits = vehicleProducts(v).indexOf(handle) !== -1;
    slot.innerHTML = fits
      ? '<div class="ac-fit ac-fit--yes"><span class="ac-fit__dot"></span>Fits your ' + escapeHtml(vehicleLabel(v)) + ' &#10003;</div>'
      : '<a class="ac-fit ac-fit--check" href="' + finderUrl(v) + '"><span class="ac-fit__dot"></span>Check fitment for your ' + escapeHtml(v.model) + ' — call 02 9188 8055</a>';
  }

  /* ---------- util ---------- */

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- boot ---------- */

  function boot() {
    renderChip();
    initConsole();
    renderProductBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
